import React, { useState, useEffect } from 'react';
import { CustomTable } from '../../../../components';
import { getRefundDetailsByBookingIdService, Columns } from '../../../../services/index.service';
import { modalNotification } from '../../../../utils';
import i18next from 'i18next';

export default function RefundDetails({ bookingId, refundId, onClose }) {
  const [loading, setLoading] = useState(true);
  const [refundData, setRefundData] = useState([]);
  const [page, setPage] = useState({
    currentPage: 1,
    sizePerPage: 10,
  });
  const { currentPage, sizePerPage } = page;

  useEffect(() => {
    fetchRefundDetails();
  }, [bookingId, refundId]);

  const fetchRefundDetails = async () => {
    setLoading(true);
    try {
      const response = await getRefundDetailsByBookingIdService(bookingId, refundId);
      if (response?.success && response?.data?.length > 0) {
        const refunds = Array.isArray(response.data) ? response.data : [response.data];
        setRefundData(refunds);
      } else {
        setRefundData([]);
        if (response?.message) {
          modalNotification({
            type: 'error',
            message: response?.message || i18next.t('text.report.refundFailedToFetch'),
          });
        }
      }
    } catch (error) {
      setRefundData([]);
      modalNotification({
        type: 'error',
        message: error?.message || i18next.t('text.report.refundErrorFetching'),
      });
    } finally {
      setLoading(false);
    }
  };

  const onTableSort = (field, order) => {
    // Sorting handled by table component
  };

  const columns = Columns.refundDetailsColumn({
    onSort: onTableSort,
    page: currentPage,
    sizePerPage,
  });

  const handleActionSelect = (e) => {
  };

  return (
    <div style={{ paddingBottom: '20px' }}>
      <CustomTable
        tableData={refundData}
        searchDisabled={true}
        tableColumns={columns}
        count={refundData?.length || 0}
        setSearchData={() => {}}
        setPage={setPage}
        sizePerPage={sizePerPage}
        currentPage={currentPage}
        tableLoader={loading}
        searchPlaceholder=""
        isModalPadding={true}
        hasLimit
        handleActionSelect={handleActionSelect}
        modalParams={false}
        showPageSizeAction={false}
        pagination={false}
        header={false}
      />
    </div>
  );
}